module.exports = __webpack_public_path__ + "img/hotelLogo-02.94280803.png";